import React, { useMemo } from 'react';
import { DayOfWeek } from 'core/day-of-week';
import { TemplateObjectType, TemplateState } from 'data/templates/api';
import {
  StatusUpdateTemplateDetails,
  FrequencyType,
} from 'data/templates/status-updates/type';
import { useTranslation } from 'hooks/use-translation';
import { useGetNewStatusUpdateTemplateQuery } from 'queries/templates/status-update-templates';
import { StatusUpdatesTemplateDetails } from './status-update-template';

const initialContent = `<p><strong>Summary</strong><br>Start writing here</p>
<p>&nbsp;</p>
<p><strong>What we've accomplished</strong><br>Start writing here</p>
<p>&nbsp;</p>
<p><strong>What's blocked</strong><br>Start writing here</p>
<p>&nbsp;</p>
<p><strong>What's next</strong><br>Start writing here</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>`;

export const NewStatusUpdatesTemplatePage = (): React.ReactElement => {
  const untitled = useTranslation('untitled');
  const { data: template } = useGetNewStatusUpdateTemplateQuery();

  const newStatusUpdateTemplate = useMemo(
    () =>
      ({
        objectType: TemplateObjectType.StatusUpdates,
        state: TemplateState.Published,
        templateName: untitled,
        templateContent: {
          content: initialContent,
          enableAutoPublish: false,
          private: false,
          criteria: {
            timeFrame: FrequencyType.Week,
            week: {
              frequency: 1,
              days: [DayOfWeek.Monday.toUpperCase()],
            },
            month: {
              frequency: 1,
              day: 1,
            },
            time: '10:00',
          },
          filters: null,
        },
        templateId: 'new',
        ...(template ?? {}),
      } as StatusUpdateTemplateDetails),
    [template, untitled],
  );

  return <StatusUpdatesTemplateDetails template={newStatusUpdateTemplate} />;
};
